export var AssessmentNodeType;
(function (AssessmentNodeType) {
    AssessmentNodeType[AssessmentNodeType["Question"] = 0] = "Question";
    AssessmentNodeType[AssessmentNodeType["Redirect"] = 1] = "Redirect";
    AssessmentNodeType[AssessmentNodeType["Form"] = 2] = "Form";
    AssessmentNodeType[AssessmentNodeType["Result"] = 3] = "Result";
    AssessmentNodeType[AssessmentNodeType["Reference"] = 4] = "Reference";
})(AssessmentNodeType || (AssessmentNodeType = {}));
function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}
export class AssessmentNode {
    constructor({ type, question, answer, title, text, preamble, price, parent, root, url, children = [], index, eventName, eventValue, eventValueName, } = {}) {
        this.type = AssessmentNodeType.Question;
        this.price = "yyy,-/month";
        this.parent = null;
        this.root = null;
        this.children = [];
        this.addChild = (child) => {
            child.parent = this;
            child.root = this.root || this;
            this.children.push(child);
        };
        this.getAscent = () => {
            let currentAncestor = this.parent;
            let ascent = 0;
            while (currentAncestor && currentAncestor !== null) {
                currentAncestor = currentAncestor.parent;
                ascent++;
            }
            return ascent;
        };
        this.getIndexPath = () => {
            let currentAncestor = this.parent;
            if (!currentAncestor)
                return [-1];
            const indexes = [currentAncestor.children.indexOf(this)];
            while (currentAncestor &&
                currentAncestor !== null &&
                currentAncestor.parent !== null) {
                indexes.unshift(currentAncestor.parent.children.indexOf(currentAncestor));
                currentAncestor = currentAncestor.parent;
            }
            return indexes;
        };
        this.getKey = () => {
            return this.getIndexPath().join(",");
        };
        this.getLabel = () => {
            var _a, _b;
            switch (this.type) {
                case AssessmentNodeType.Question:
                    return this.question || "";
                case AssessmentNodeType.Form:
                    return "Form";
                case AssessmentNodeType.Reference:
                    return `Reference to ${(_b = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.children[this.index]) === null || _b === void 0 ? void 0 : _b.answer}`;
                case AssessmentNodeType.Redirect:
                    return `Redirect to ${this.url}`;
                case AssessmentNodeType.Result:
                    return `Result - ${this.title}`;
                default:
                    return this.title || "";
            }
        };
        this.getMaxDepth = (withAscent = false) => {
            const ascent = withAscent ? this.getAscent() : 0;
            return ascent + this.getMaxDepthOfNode(this);
        };
        this.getMaxDepthOfNode = (node) => {
            if (node.children.length === 0)
                return 0;
            let maxDepth = 0;
            for (const child of node.children) {
                maxDepth = Math.max(maxDepth, this.getMaxDepthOfNode(child));
            }
            return maxDepth + 1;
        };
        this.type = type || this.type;
        this.question = question || "";
        this.answer = answer || "";
        this.title = title || "";
        this.text = text || "";
        this.preamble = preamble || "";
        this.price = price || "";
        this.parent = parent || null;
        this.root = root || null;
        this.url = url || "";
        this.index = index || 0;
        this.eventName = eventName;
        this.eventValue = eventValue;
        this.eventValueName = eventValueName;
        children.forEach(this.addChild);
    }
    getDistinctStrings() {
        const myStrings = this.getStrings();
        return this.children
            .reduce((r, c) => c.getDistinctStrings().concat(r), myStrings)
            .filter(onlyUnique);
    }
    getStrings() {
        return [
            this.question,
            this.answer,
            this.title,
            this.text,
            this.preamble,
            this.price,
            this.url,
        ].filter((s) => !!s);
    }
    getDistinctLabels(labels = []) {
        const label = this.getLabel();
        if (labels.indexOf(label) === -1) {
            labels.push(label);
        }
        if (this.children.length > 0) {
            this.children.forEach((c) => {
                c.getDistinctLabels(labels);
            });
        }
        return labels;
    }
    clone({ type, question, answer, title, text, preamble, price, parent, root, children, url, index, eventName, eventValue, eventValueName, } = {}) {
        return new AssessmentNode({
            answer: answer || this.answer,
            title: title || this.title,
            text: text || this.text,
            preamble: preamble || this.preamble,
            price: price || this.price,
            parent: parent || this.parent || undefined,
            root: root || this.root || undefined,
            question: question || this.question,
            type: type || this.type,
            children: children || this.children.map((c) => c.clone()),
            url: url || this.url,
            index: typeof index === "number" ? index : this.index,
            eventName: eventName || this.eventName,
            eventValue: eventValue || this.eventValue,
            eventValueName: eventValueName || this.eventValueName,
        });
    }
    toJSON() {
        const sharedData = {
            type: this.type || undefined,
            answer: this.answer || undefined,
            eventName: this.eventName || undefined,
            eventValue: this.eventValue || undefined,
            eventValueName: this.eventValueName || undefined,
        };
        switch (this.type) {
            case AssessmentNodeType.Reference:
                return Object.assign({ index: this.index }, sharedData);
            case AssessmentNodeType.Redirect:
                return Object.assign({ url: this.url }, sharedData);
            case AssessmentNodeType.Result:
                return Object.assign({ title: this.title || undefined, text: this.text || undefined, price: this.price || undefined, preamble: this.preamble || undefined }, sharedData);
            case AssessmentNodeType.Form:
            case AssessmentNodeType.Question:
                return Object.assign({ title: this.title || undefined, text: this.text || undefined, question: this.question || undefined, children: this.children.length > 0 ? this.children : undefined }, sharedData);
        }
    }
}
